import { createModuleLayout } from "@/lib/create-module-layout";
import { MODULES } from "@kubdee/shared/module-ids";
import purchaseModule from "@kubdee/module-purchase";

export default createModuleLayout({
  moduleId: MODULES.PURCHASE,
  moduleConfig: purchaseModule,
});
